import { AirbnbFeeType, AirbnbFeeUnitType } from 'models/PropertyFees';

export const BY_LENGTH_OF_STAY_SCOPE_OPTION = 'BY_LENGTH_OF_STAY';

export const AIRBNB_PERCENT_FEE_TYPES = [
  AirbnbFeeType.PASS_THROUGH_RESORT_FEE,
  AirbnbFeeType.PASS_THROUGH_MANAGEMENT_FEE,
  AirbnbFeeType.PASS_THROUGH_COMMUNITY_FEE,
];

export const AIRBNB_UNIT_TYPE_OPTIONS_MAPPING = {
  [AirbnbFeeType.PASS_THROUGH_AIR_CONDITIONING_FEE]: [
    AirbnbFeeUnitType.PER_KILOWATT_HOUR,
    AirbnbFeeUnitType.PER_LITER,
    AirbnbFeeUnitType.PER_CUBIC_METER,
  ],
  [AirbnbFeeType.PASS_THROUGH_ELECTRICITY_FEE]: [
    AirbnbFeeUnitType.PER_KILOWATT_HOUR,
  ],
  [AirbnbFeeType.PASS_THROUGH_HEATING_FEE]: [
    AirbnbFeeUnitType.PER_KILOWATT_HOUR,
  ],
  [AirbnbFeeType.PASS_THROUGH_UTILITY_FEE]: [
    AirbnbFeeUnitType.PER_KILOWATT_HOUR,
    AirbnbFeeUnitType.PER_LITER,
    AirbnbFeeUnitType.PER_CUBIC_METER,
  ],
  [AirbnbFeeType.PASS_THROUGH_WATER_FEE]: [
    AirbnbFeeUnitType.PER_LITER,
    AirbnbFeeUnitType.PER_CUBIC_METER,
  ],
} as const;
